import script from "./CostPerLeadChart.vue?vue&type=script&setup=true&lang=js"
export * from "./CostPerLeadChart.vue?vue&type=script&setup=true&lang=js"

import "./CostPerLeadChart.vue?vue&type=style&index=0&id=54cb030c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54cb030c"]])

export default __exports__